import { IntegrationComponent } from './integration/integration.component';
import { AboutServiceComponent } from './about-service/about-service.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactsComponent } from './contacts/contacts.component';
import { FaqComponent } from './faq/faq.component';
import { LandingPageComponent } from './landing-page/landing-page.component';

import { PublicComponent } from './public.component';
import { TermsComponent } from './terms/terms.component';
import {HowToAddDeliveryComponent} from './how-to-add-delivery/how-to-add-delivery.component';
import {DeliveryOptionsComponent} from './delivery-options/delivery-options.component';
import { IntegratedServiceProviderComponent } from './integrated-service-provider/integrated-service-provider.component';
import {AddDeliveryComponent} from './add-delivery/add-delivery.component';
import {SearchOrderComponent} from './add-delivery/search-order/search-order.component';

const routes: Routes =
  [
    {
      path: '', component: PublicComponent,
      children: [
        { path: '', redirectTo: 'landing-page' },
        { path: 'landing-page', component: LandingPageComponent },
        { path: 'shipping', loadChildren: () => import('./shipping/shipping.module').then(m => m.ShippingModule) },
        { path: 'tracking', loadChildren: () => import('./tracking/tracking.module').then(m => m.TrackingModule) },
        { path: 'terms-and-conditions', component: TermsComponent },
        { path: 'faq', component: FaqComponent },
        { path: 'contacts', component: ContactsComponent },
        {path: 'how-to-add-delivery', component: HowToAddDeliveryComponent},
        {path: 'delivery-options', component: DeliveryOptionsComponent},
        {path: 'about-service', component: AboutServiceComponent},
        {path: 'integration', component: IntegrationComponent},
        {path: 'integrated-service-providers', component: IntegratedServiceProviderComponent},
        
        {path: 'add-delivery/:id', component: SearchOrderComponent}


      ]
    },
    { path: '**', redirectTo: '', pathMatch: 'full' }


  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
